export const SITE = {
  name: "Axomind Asset Services LLP",
  short: "Axomind",
  tagline: "Intelligent Investing. Enduring Results.",
  amfi: "AMFI Registered Mutual Fund Distributor",
  arn: "ARN-365843",
  amfiFull: "AMFI Registered Mutual Fund Distributor | ARN-365843",
  phone: "+91 84120 33559",
  phoneRaw: "918412033559",
  email: "investorservice@axomindasset.com",
  website: "www.axomindasset.com",
  websiteUrl: "https://www.axomindasset.com",
  address:
    "Boston House, 7th Floor, Suren Road, Near WEH Metro Station, Chakala, Andheri East, Mumbai 400093",
  shortAddress: "Andheri East, Mumbai",
  mapEmbedSrc:
    "https://www.google.com/maps?q=Boston+House+Suren+Road+Andheri+East+Mumbai+400093&output=embed",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_premium-portfolio-130/artifacts/r9crcacp_A311E0A7-C559-4C6B-A7B8-6DA273AAB575.PNG",
  founderPhoto:
    "https://customer-assets.emergentagent.com/job_premium-portfolio-130/artifacts/zytgi6k0_WhatsApp%20Image%202026-06-30%20at%205.15.42%20PM.jpeg",
  socials: {
    linkedin: "https://www.linkedin.com/in/abhijit-deshmukh-8ba59728",
    twitter: "https://twitter.com/",
    instagram: "https://www.instagram.com/",
    facebook: "https://www.facebook.com/",
  },
};

export const FOUNDER = {
  name: "Abhijit Deshmukh",
  title: "Founder & Principal — Axomind Asset Services LLP",
  photo: SITE.founderPhoto,
  short:
    "Two decades of hands-on asset management experience across India's most respected AMCs — translated into disciplined, investor-first distribution services.",
  bio: [
    "Abhijit Deshmukh is the Founder of Axomind Asset Services LLP and brings two decades of hands-on asset management experience from some of India's most respected asset managers — including TATA Asset Management, SBI Mutual Fund and Kotak Mahindra AMC.",
    "He is regarded for his rigorous approach to product research, fund evaluation and macro positioning. Over his career, he has built a value-addition pool serving both individual and corporate investors, helping hundreds of clients translate complex market constructs into clear, actionable plans.",
    "Abhijit holds an MBA (Finance) from Symbiosis and is certified by the CFA Institute Investment Foundations Program (USA). His philosophy is simple: rigorous research, structured execution, and an unwavering commitment to client outcomes.",
  ],
  credentials: [
    "MBA (Finance), Symbiosis",
    "CFA Institute — Investment Foundations (USA)",
    "20+ Years • TATA AMC, SBI MF, Kotak AMC",
  ],
};
